import { getGlobalClassNames } from '../../Styling';
var GlobalClassNames = {
  root: 'ms-DetailsList',
  compact: 'ms-DetailsList--Compact',
  contentWrapper: 'ms-DetailsList-contentWrapper',
  headerWrapper: 'ms-DetailsList-headerWrapper',
  isFixed: 'is-fixed',
  isHorizontalConstrained: 'is-horizontalConstrained',
  listCell: 'ms-List-cell'
};
export var getDetailsListStyles = function (props) {
  var _a, _b;
  var theme = props.theme,
    className = props.className,
    isHorizontalConstrained = props.isHorizontalConstrained,
    compact = props.compact,
    isFixed = props.isFixed;
  var semanticColors = theme.semanticColors;
  var classNames = getGlobalClassNames(GlobalClassNames, theme);
  return {
    root: [classNames.root, theme.fonts.small, {
      position: 'relative',
      color: semanticColors.listText,
      selectors: (_a = {}, _a["& .".concat(classNames.listCell)] = {
        minHeight: 38,
        wordBreak: 'break-word'
      }, _a)
    }, isFixed && classNames.isFixed, compact && [classNames.compact, {
      selectors: (_b = {}, _b[".".concat(classNames.listCell)] = {
        minHeight: 32
      }, _b)
    }], isHorizontalConstrained && [classNames.isHorizontalConstrained, {
      overflowX: 'auto',
      overflowY: 'visible',
      WebkitOverflowScrolling: 'touch'
    }], className],
    focusZone: [{
      display: 'inline-block',
      minWidth: '100%',
      minHeight: 1
    }],
    headerWrapper: classNames.headerWrapper,
    contentWrapper: classNames.contentWrapper
  };
};